import { render, staticRenderFns } from "./IFRPDF.vue?vue&type=template&id=2008a9ef"
import script from "./IFRPDF.vue?vue&type=script&lang=js"
export * from "./IFRPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports